import React, { useState } from "react";

import { useFormikContext } from "formik";

import { Divider, Flex, Grid, GridItem, Text } from "@chakra-ui/react";

import { Group } from "../../Group";
import { CustomInputWField } from "../../../../../components/CustomInputWField";
import CustomDropzone from "../../../../../components/CustomDropzone";
import { RadioOptions } from "../../RadioOptions";
import { cpf } from "../../../../../utils/masks";

export const PossuiCPF = ({
  invalidCPF,
  acolhedorValid,
  message,
  idAnexo,
  scrollToField,
}) => {
  const { setFieldValue, values, errors, touched } = useFormikContext();
  const [isFocused, setIsFocused] = useState(false);
  const [isBlur, setIsBlur] = useState(false);

  return (
    <Group
      border={idAnexo === "4" ? "3px solid #4299E199" : ""}
      scrollToField={idAnexo === "4" ? scrollToField : null}
    >
      <Text
        mt="5"
        mb="2"
        fontWeight={700}
        fontSize="16px"
        lineHeight="21.6px"
        color="#169499"
      >
        CPF
      </Text>
      <Divider mb="5" />
      <RadioOptions
        label="Possui CPF?*"
        fieldName="possuiCpf"
        errors={errors}
        touched={touched}
      />
      {values.possuiCpf === "S" && (
        <>
          <Grid
            mt="15px"
            templateColumns="repeat(5, 1fr)"
            gap="25px"
            rowGap="20px"
          >
            <GridItem colSpan={{ base: 2, sm: 2, lg: 2 }}>
              <CustomInputWField
                fieldName="cpf"
                label="Número do CPF*"
                placeholder="000.000.000-00"
                maxLength={14}
                onChange={(e) => setFieldValue("cpf", cpf(e.target.value))}
                setIsFocused={setIsFocused}
                setIsBlur={
                  values?.cpf?.replace(/[^\d]+/g, "").length === 11 && setIsBlur
                }
              />
              {!errors.cpf &&
                values.cpf &&
                !isFocused &&
                !invalidCPF &&
                !isBlur && (
                  <Text color="red" opacity={0.8} mt={2} fontSize="12px">
                    Informar um CPF válido
                  </Text>
                )}
              {!errors.cpf &&
                values.cpf &&
                !isFocused &&
                acolhedorValid &&
                invalidCPF &&
                !isBlur && (
                  <Text color="red" opacity={0.8} mt={2} fontSize="12px">
                    {message ? message : ""}
                  </Text>
                )}
            </GridItem>
            <GridItem
              display={{ base: "none", sm: "none", lg: "block" }}
              colSpan={{ base: 2, sm: 2, lg: 1 }}
            />
          </Grid>
          <Grid mt="25px" templateColumns="repeat(4, 1fr) 1fr" gap="25px">
            <GridItem colSpan={{ base: 2, sm: 2, lg: 1 }}>
              <Flex>
                <CustomDropzone
                  whiteSpace={true}
                  formProps={{ setFieldValue }}
                  title="Anexar CPF"
                  fieldName="anexoCpf"
                  height="42px"
                  width={"216px"}
                />
              </Flex>
            </GridItem>
          </Grid>
        </>
      )}
    </Group>
  );
};
